import { NotificationsUtilsService } from './notifications-utils.service';

export default angular
  .module('sfMobile.services.notifications-utils', ['sfMobile.services.dates'])
  .service('notificationsUtilsService', NotificationsUtilsService).name;
